import http from './http'

export default class PageAPI {
	//获取发票列表
	static listByUserid(data) {
		return http.httpGet('/invoice/ticket/listByUserid', data)
	}

	//填写发票信息
	static addTicket(data) {
		return http.httpPost('/invoice/ticket/addTicket', data)
	}

	//添加发票订单
	static addOrder(data) {
		return http.httpPost('/lavrock/ninvoice/order', data)
	}

	static downInvoice(data) {
		return http.httpGet('/invoice/ticket/order', data)
	}

	// 获取专票开具额度
	static getProfInvoiceLimitMoney() {
		return http.httpGet('/lavrock/ninvoice/limit')
	}
	/**
	 * 获取上次提交的专票信息
	 * @param {String} params.uid
	 */
	static getProfLastInvoice(params) {
		return http.httpGet('/lavrock/ninvoice/lastInvoice', params)
	}

	static checkContract(params) {
		return http.httpGet('/order/checkContract', params)
	}
}
